import React from 'react';
import { useTranslation } from 'react-i18next';
import UpDownArrowIcon from '../../Icons/UpDownArrowIcon';
function LevelNavigationButtons({ safeLevel, setCurrentLevel }) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-start ">
      <button
        className="bg-white !border !border-solid border-gray-300 flex items-center justify-center p-4 disabled:opacity-50 w-[52px] h-[52px] focus:outline-none"
        onClick={() => {
          if (safeLevel === 0) {
            setCurrentLevel(1);
          } else if (safeLevel === 1) {
            setCurrentLevel(0);
          }
        }}
        disabled={safeLevel !== 0 && safeLevel !== 1}
        aria-label={
          safeLevel === 0
            ? 'Go to level 1'
            : safeLevel === 1
              ? 'Go to Grundniveau'
              : ''
        }
      >
        <UpDownArrowIcon
          direction={safeLevel === 0 ? 'up' : 'down'}
          className="h-[15px] w-[15px]"
        />
      </button>
      <span
        className="ml-0 flex items-center text-black p-4 text-sm"
        style={{ backgroundColor: '#DDDDDD' }}
      >
        {safeLevel === 0 ? t('ground_floor') : t('first_floor')}
      </span>
    </div>
  );
}

export default LevelNavigationButtons;

//TODO add translations for "Grundniveau" and "Floor " + safeLevel
